import axios from 'axios'

export const state = {
  suppliers : {},
  supplier : {}
}

export const getters = {
  listSuppliers (state) {
    return state.suppliers
  },
  detailSupplier (state) {
    return state.supplier
  },
}

export const mutations = {
  SET_SUPPLIERS (state, suppliers) {
    state.suppliers = suppliers
  },
  SET_SUPPLIER (state, supplier) {
    state.supplier = supplier
  },
  TOGGLE_SHOW_DETAIL (state, id) {
    state.suppliers.data.forEach((item, index) => {
      if (item.id === id) {
        item._showDetails = !item._showDetails;
        state.suppliers.data.splice(index, 1)
        state.suppliers.data.splice(index, 0, item)
      }
    });
  },
}

export const actions = {
  getSuppliers({ commit }, params = {}) {
    return axios.get(`/suppliers`, { params }).then(({ data }) => {
      return commit('SET_SUPPLIERS', data)
    })
  },
  searchSuppliers({ commit }, params = {}) {
    return axios.get('/suppliers/search', { params })
  },
  getListSuppliers({ commit }, params = {}) {
    return axios.get('/suppliers', { params })
  },
  getSupplier({ commit }, id) {
    return axios.get(`/suppliers/${id}`)
  },
  deleteSupplier({ commit }, id) {
    return axios.delete(`/suppliers/${id}`)
  },
  exportSuppliersCsv({commit}, params = {}) {
    return axios.get('/suppliers/export', { params, responseType: 'blob' });
  },
  createSupplier({ commit }, supplier) {
    const data = {
      name: supplier.name,
      abn: supplier.abn,
      acn: supplier.acn,
      status: supplier.status,
      term_id: supplier.term ? supplier.term.id : null,
      sale_reps: supplier.sale_reps ? parseUpdateSaleRep(supplier.sale_reps) : [],
      addresses: supplier.addresses ? parseAddresses(supplier.addresses) : [],
      contacts: supplier.contacts ? parseUpdateContacts(supplier.contacts) : [],
      types: supplier.types ? supplier.types : {},
    }
    return axios.post('/suppliers', data)
  },
  updateSupplier({commit}, supplier) {
    const data = {
      name: supplier.name,
      abn: supplier.abn,
      acn: supplier.acn,
      status: supplier.status,
      term_id: supplier.term ? supplier.term.id : null,
      sale_reps: parseUpdateSaleRep(supplier.sale_reps),
      addresses: parseUpdateAddress(supplier.addresses),
      contacts: parseUpdateContacts(supplier.contacts),
      types: supplier.types ? supplier.types : {},
    }
    return axios.put(`/suppliers/${supplier.id}`, data)
  },
  toggleDataDetails: function({commit}, index) {
    return commit('TOGGLE_SHOW_DETAIL', index)
  },
  importSupplier({commit}, params = {}) {
    const formData = new FormData()
    formData.append('file', params.file, params.file.name)
    formData.append('type', params.type)
    formData.append('force_save', params.force_save)
    formData.append('download_error', params.download_error)
    const responseType = params.download_error ? 'blob' : 'json'
    return axios.post('/suppliers/import', formData, {responseType: responseType})
  },
  downloadImportSuppliersTemplate({ commit }, params = {} ) {
    return axios.get(`/import/supplier/download-template`, {responseType: 'blob'})
  },
}

function parseAddresses(addresses) {
  const arrayAddresses = []
  addresses.forEach((item) => {
    const address = {...item}
    address.types = item.types.map(type => type.name)
    arrayAddresses.push(address)
  })
  return arrayAddresses
}

function parseUpdateSaleRep(saleReps) {
  const arraySales = []
  saleReps.forEach((item) => {
    const saleRep = {...item}
    saleRep.staff_id = saleRep.staff ? saleRep.staff.id : null;
    saleRep.types = item.types ? item.types.map(type => type.name) : []
    arraySales.push(saleRep)
  })
  return arraySales
}

function parseUpdateAddress(addresses) {
  const arrayAddresses = []
  addresses.forEach((item) => {
    const address = {...item}
    address.country_id = address.country_id || (address.country && address.country.id)
    address.types = item.types ? item.types.map(type => type.name) : []
    arrayAddresses.push(address)
  })
  return arrayAddresses
}

function parseUpdateContacts(contacts) {
  const arrayContacts = []
  contacts.forEach((item) => {
    const contacts = {...item}
    if (contacts.address) {
      contacts.address_id = contacts.address.id
    }
    if (contacts.role) {
      contacts.role_id = contacts.role.id
    }
    arrayContacts.push(contacts)
  })
  return arrayContacts
}
